/* JAPYLUTS — interacciones · HEREX */
(function () {
  'use strict';
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var slow = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---------- Cursor punto negro ---------- */
  if (fine) {
    var dot = document.createElement('div'); dot.className = 'jl-cur';
    var ring = document.createElement('div'); ring.className = 'jl-ring';
    document.body.appendChild(dot); document.body.appendChild(ring);
    var mx = -100, my = -100, rx = -100, ry = -100;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = 'translate(' + mx + 'px,' + my + 'px) translate(-50%,-50%)';
    });
    (function loop() {
      rx += (mx - rx) * 0.16; ry += (my - ry) * 0.16;
      ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)';
      requestAnimationFrame(loop);
    })();
    document.addEventListener('mouseover', function (e) {
      var t = e.target.closest('a,button,.card,.jl-slider,input,summary');
      if (t) { dot.classList.add('big'); ring.classList.add('hide'); }
    });
    document.addEventListener('mouseout', function (e) {
      var t = e.target.closest('a,button,.card,.jl-slider,input,summary');
      if (t) { dot.classList.remove('big'); ring.classList.remove('hide'); }
    });
    document.addEventListener('mouseleave', function () {
      dot.style.opacity = 0; ring.style.opacity = 0;
    });
    document.addEventListener('mouseenter', function () {
      dot.style.opacity = 1; ring.style.opacity = 1;
    });
  }

  /* ---------- Reveal al hacer scroll ---------- */
  var rv = document.querySelectorAll('.rv,.clip');
  if ('IntersectionObserver' in window && !slow) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    rv.forEach(function (el) { io.observe(el); });
  } else {
    rv.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- Header sticky ---------- */
  var hd = document.querySelector('.hd');
  if (hd) {
    var onScroll = function () { hd.classList.toggle('stuck', window.scrollY > 24); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Parallax suave del hero ---------- */
  var pbg = document.querySelectorAll('[data-par]');
  if (pbg.length && !slow) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      pbg.forEach(function (el) {
        var s = parseFloat(el.getAttribute('data-par')) || 0.14;
        el.style.transform = 'translate3d(0,' + (y * s) + 'px,0) scale(1.08)';
      });
    }, { passive: true });
  }

  /* ---------- Deslizable antes / después ---------- */
  document.querySelectorAll('.jl-slider').forEach(function (sl) {
    var after = sl.querySelector('.jl-after');
    var line = sl.querySelector('.jl-line');
    var knob = sl.querySelector('.jl-knob');
    if (!after) return;
    var drag = false;
    function set(p) {
      p = Math.max(0, Math.min(100, p));
      after.style.clipPath = 'inset(0 0 0 ' + p + '%)';
      if (line) line.style.left = p + '%';
      if (knob) knob.style.left = p + '%';
    }
    function fromEvent(e) {
      var r = sl.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      set((x / r.width) * 100);
    }
    sl.addEventListener('mousedown', function (e) { drag = true; fromEvent(e); e.preventDefault(); });
    window.addEventListener('mouseup', function () { drag = false; });
    window.addEventListener('mousemove', function (e) { if (drag) fromEvent(e); });
    sl.addEventListener('mousemove', function (e) { if (!drag && sl.dataset.hover !== 'off') fromEvent(e); });
    sl.addEventListener('touchstart', function (e) { fromEvent(e); }, { passive: true });
    sl.addEventListener('touchmove', function (e) { fromEvent(e); }, { passive: true });
    set(50);
  });

  /* ---------- FAQ ---------- */
  document.querySelectorAll('.q button').forEach(function (b) {
    b.addEventListener('click', function () {
      var q = b.parentElement, a = q.querySelector('.q-a');
      var open = q.classList.contains('open');
      q.parentElement.querySelectorAll('.q.open').forEach(function (o) {
        o.classList.remove('open'); o.querySelector('.q-a').style.maxHeight = null;
      });
      if (!open) { q.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });

  /* ---------- Duplicar marquesinas para bucle continuo ---------- */
  document.querySelectorAll('[data-loop]').forEach(function (t) {
    t.innerHTML += t.innerHTML;
  });

  /* ---------- Barra de progreso de scroll ---------- */
  var prog = document.createElement('div'); prog.className = 'jl-prog';
  document.body.appendChild(prog);
  function setProg() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    prog.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
  }
  window.addEventListener('scroll', setProg, { passive: true }); setProg();

  /* ---------- Magic reveal 3D ---------- */
  var m3 = document.querySelectorAll('.m3,.wipe,.split,.a');
  if ('IntersectionObserver' in window && !slow) {
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        if (el.classList.contains('split')) {
          var kids = el.querySelectorAll('i');
          kids.forEach(function (k, i) { k.style.transitionDelay = (i * 0.045) + 's'; });
        }
        el.classList.add('in'); io2.unobserve(el);
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });
    m3.forEach(function (el) { io2.observe(el); });
  } else {
    m3.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- Inclinacion 3D con el mouse ---------- */
  if (fine && !slow) {
    document.querySelectorAll('.tilt').forEach(function (el) {
      var max = parseFloat(el.dataset.tilt) || 9;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        el.style.transform = 'perspective(1000px) rotateY(' + ((px - .5) * max * 2).toFixed(2) +
          'deg) rotateX(' + ((.5 - py) * max * 2).toFixed(2) + 'deg) translateY(-8px) scale(1.02)';
        el.style.setProperty('--mx', (px * 100) + '%');
        el.style.setProperty('--my', (py * 100) + '%');
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Capas con desplazamiento continuo ---------- */
  var layers = document.querySelectorAll('[data-depth]');
  if (layers.length && !slow) {
    var tick = false;
    function moveLayers() {
      var vh = window.innerHeight;
      layers.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var d = parseFloat(el.getAttribute('data-depth')) || 0.1;
        var mid = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (-mid * d).toFixed(1) + 'px,0)';
      });
      tick = false;
    }
    window.addEventListener('scroll', function () {
      if (!tick) { tick = true; requestAnimationFrame(moveLayers); }
    }, { passive: true });
    moveLayers();
  }

  /* ---------- Router de sub-paginas ---------- */
  var panels = document.querySelectorAll('.sub');
  if (panels.length) {
    var scrollY = 0, active = null;

    function playReveals(root) {
      root.querySelectorAll('.a,.m3,.wipe').forEach(function (e) {
        e.classList.remove('in');
      });
      setTimeout(function () {
        root.querySelectorAll('.a,.m3,.wipe').forEach(function (e) { e.classList.add('in'); });
      }, 300);
    }

    function openSub(panel, data, ev) {
      if (!panel || active) return;
      var ox = ev && ev.clientX ? ev.clientX : window.innerWidth / 2;
      var oy = ev && ev.clientY ? ev.clientY : window.innerHeight / 2;
      panel.style.setProperty('--ox', ox + 'px');
      panel.style.setProperty('--oy', oy + 'px');

      if (data) {
        var set = function (sel, val, attr) {
          var n = panel.querySelector(sel); if (!n || val == null) return;
          if (attr) n.setAttribute(attr, val); else n.textContent = val;
        };
        set('[data-f=title]', data.title);
        set('[data-f=price]', data.price);
        set('[data-f=compare]', data.compare);
        set('[data-f=desc]', data.desc);
        set('[data-f=img]', data.img, 'src');
        var cmp = panel.querySelector('[data-f=compare]');
        if (cmp) cmp.style.display = data.compare ? '' : 'none';
        var save = panel.querySelector('[data-f=save]');
        if (save) save.style.display = data.compare ? '' : 'none';
        var raw = panel.querySelector('[data-f=raw]'), lut = panel.querySelector('[data-f=lut]');
        if (raw && data.raw) raw.setAttribute('src', data.raw);
        if (lut && data.lut) lut.setAttribute('src', data.lut);
      }

      scrollY = window.scrollY;
      document.body.classList.add('locked');
      document.body.style.top = (-scrollY) + 'px';
      panel.classList.add('open');
      panel.scrollTop = 0;
      active = panel;
      if (history.pushState) history.pushState({ sub: panel.id }, '', '#' + panel.id);
      playReveals(panel);
    }

    function closeSub(pop) {
      if (!active) return;
      active.classList.remove('open');
      active = null;
      document.body.classList.remove('locked');
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
      if (!pop && history.state && history.state.sub) history.back();
    }

    document.querySelectorAll('[data-open]').forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        var panel = document.getElementById(c.getAttribute('data-open'));
        openSub(panel, {
          title: c.dataset.title, price: c.dataset.price, compare: c.dataset.compare,
          desc: c.dataset.desc, img: c.dataset.img, raw: c.dataset.raw, lut: c.dataset.lut
        }, e);
      });
    });

    panels.forEach(function (p) {
      p.querySelectorAll('[data-close]').forEach(function (b) {
        b.addEventListener('click', function () { closeSub(); });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSub();
    });
    window.addEventListener('popstate', function () { closeSub(true); });
  }

  /* ---------- Rotacion 3D ligada al scroll ---------- */
  var spin = document.querySelectorAll('[data-spin]');
  if (spin.length && !slow) {
    var st = false;
    function doSpin() {
      var vh = window.innerHeight;
      spin.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        var amt = parseFloat(el.getAttribute('data-spin')) || 10;
        el.style.transform = 'perspective(1400px) rotateY(' + (p * amt).toFixed(2) + 'deg) rotateX(' +
          (-p * amt * 0.45).toFixed(2) + 'deg)';
      });
      st = false;
    }
    window.addEventListener('scroll', function () {
      if (!st) { st = true; requestAnimationFrame(doSpin); }
    }, { passive: true });
    doSpin();
  }
})();
